import { Campaign } from './campaign'
import { SalesStage } from './chains'
import { CompanyDistributor, CompanyGPO, SubCategory } from './companies'
import { Deal } from './deals'
import { Tag } from './tags'
import { User } from './user'

export interface IContactCompany {
  contact_count: number
  note_count: number
  deal_count: number
  taglist: Tag[] | undefined
  id: number
  chain: any
  university_id: number
  hospital_id: number
  nursing_home_id: number
  k12district_id: number
  lodging_id: number
  cstore_id: number
  domain: string
  name: string
  count: number
  category: string
  category_slug: string
  category_id: number
  sub_category: SubCategory
  sub_category_id: number
  created: string
  modified?: string
  note: IContactCompanyNote
  distributors?: CompanyDistributor[]
  gpos?: CompanyGPO[]
  campaigns: Campaign[]
  address: string
  city: string
  state: string
  country: string
  zipcode: string
  phone_number: string
  extension: string
  google_place_url?: string
  is_unmatched: boolean
  doors_count?: number
}

export interface IContactCompanyNote {
  sales_stage: SalesStage
  taglist: Tag[]
  account_owner: User
  notes: string
}

export interface IContactCompanyNoteCreateRequest
  extends Omit<
    IContactCompanyNote,
    'account_owner' | 'taglist' | 'sales_stage'
  > {
  sales_stage: number
  taglist?: number[] | 'REMOVE'
  account_owner: number
}

export interface IContactCompanyCreateRequest {
  domain: string
  name: string
  category: number
  sub_category: number
  taglist?: number[] | 'REMOVE'
  distributors?: number[]
  address?: string
  country: string
  city?: string
  state?: string
  zipcode?: string
  phone_number?: string
  extension?: string
  google_place_url?: string
}

export interface IContactCompanyUpdateRequest
  extends Omit<IContactCompanyCreateRequest, 'name'> {}

export interface NoteAttachment {
  id: number
  file: string
  original_filename: string
}

export interface INote {
  id: number
  content: string
  created: string
  user: {
    id: number
    email: string
    first_name: string
    last_name: string
    company: number
  }
  modified: string
  company: number
  contact_company: number
  door_proxy?: {
    id: number
    name: string
    address: string
    city: string
    state: string
    zipcode: string
    country: string
    taglist: Tag[]
  }
  attachments: any[]
  mentions_me?: boolean
}

export interface IDoorProxyWrite {
  name: string
  domain: string
  address: string
  country: string
  city: string
  state: string
  zipcode: string
  phone_number?: string
  extension?: string
}

export interface IDoorProxy extends IDoorProxyWrite {
  id: number
  chain_proxy: number
  restaurant_id?: number
  lodging_id?: number
  cstore_id?: number
  created: string
  note_count?: number
  deal_count?: number
  contact_count?: number
  chain_size?: number
  taglist?: Tag[]
  distributors?: CompanyDistributor[]
  gpos?: CompanyGPO[]
  campaigns?: Campaign[]
  deals?: Deal[]
}

export type IDoorProxyCreateRequest = IDoorProxyWrite
export type IDoorProxyEditRequest = IDoorProxyWrite

// UI should have knowledge of available contact company types
// without needing to fetch from server
export enum ContactCompanyType {
  Chain = 'restaurant',
  University = 'university',
  K12District = 'k12district',
  UserGenerated = 'user_generated',
  Hospital = 'hospital',
  NursingHome = 'nursinghome',
  Lodging = 'lodging',
  Convenience = 'convenience',
}
